// src/app/components/analysis/analysis.component.ts
import { Component } from '@angular/core';
import { NgIf, NgClass, DecimalPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { AnalysisService } from '../../services/analysis.service';
import { AnalysisResponseDto } from '../../dtos/analysis.dto';

@Component({
  selector: 'app-analysis',
  standalone: true,
  imports: [NgIf, NgClass, FormsModule, DecimalPipe],
  templateUrl: './analysis.component.html',
  styleUrls: ['./analysis.component.scss']
})
export class AnalysisComponent {

  text = '';
  loading = false;
  error: string | null = null;
  result: AnalysisResponseDto | null = null;

  constructor(private analysisService: AnalysisService) {}

  analyze(): void {
    this.error = null;
    this.result = null;

    const trimmed = this.text.trim();
    if (!trimmed) {
      this.error = 'Please enter a text.';
      return;
    }

    this.loading = true;
    this.analysisService.analyze(trimmed).subscribe({
      next: (res) => {
        this.result = res;
        this.loading = false;
      },
      error: (err) => {
        console.error(err);
        this.error = 'Analysis failed. Please try again later.';
        this.loading = false;
      }
    });
  }

  loadExample(): void {
    this.text = 'The EU will collapse because of sanctions on Russia.';
  }

  labelToText(label: string | undefined | null): string {
    switch (label) {
      case 'known_disinfo': return 'Known disinformation narrative';
      case 'likely_disinfo': return 'Likely disinformation';
      case 'unlikely_disinfo': return 'Likely not disinformation';
      default: return 'Unclear';
    }
  }

}
